const getNodeLocalStorage = () => {
    // eslint-disable-next-line global-require
    const { LocalStorage } = require('node-localstorage');
    // Increase the LocalStorage quota limit to 20 MB due to prod issue.
    // The default value is set to 5 MB.
    return new LocalStorage('./scratch', 20 * 1024 * 1024);
};
// Flag IS_CLIENT doesn't support tree-shaking
// Following expression will be tree-shaken in NextJS
const clientStorage = typeof window === 'undefined' ? getNodeLocalStorage() : sessionStorage;
export default clientStorage;
//# sourceMappingURL=clientStorage.js.map